<ng-container>
    <span container="body">
      <span class="status-icon" *ngIf="params.data.lastRunOutcomeStatus == 'Executing'">
        <img src="../../../../assets/icons/Processing.png">        
      </span>
      <span class="status-icon" *ngIf="params.data.lastRunOutcomeStatus == 'Succeeded'">
        <img src="../../../../assets/icons/Checkmark.png">
      </span>
      <span class="status-icon" *ngIf="params.data.lastRunOutcomeStatus == 'Failed'">
        <img src="../../../../assets/icons/ErrorIcon.png" > 
      </span>
      {{ params.value }}
    </span>
  </ng-container>